/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} My_Grower_Report_WindowInputs */

const vi_my_grower_report_window = /** @type {(inputs: My_Grower_Report_WindowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Từ ${i?.from} đến ${i?.to}`)
};

/**

* @param {My_Grower_Report_WindowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_window = /** @type {((inputs: My_Grower_Report_WindowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_WindowInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_window(inputs)
});